module.exports = __webpack_public_path__ + "images/referenzen/animationsfilm/edeka_zitrus_social_media_content_small.jpg";